module.exports = __webpack_public_path__ + "img/block_1.cdb28f91.png";